<div
  [class]="'card-header ' + brandColor + colorize + ' ' + andClass"
  [ngClass]="{ 'brand-card-header': brandCard, colorize: colorize }"
  [class.transparent]="transparent"
  [class.card-list]="cardList">
  @if (title) {
    <span class="card-heading">
      @if (favicon) {
        <i [class]="'fa ' + favicon"></i>
      }
      {{ title }}
    </span>
  }
  <ng-content></ng-content>
</div>
<!--Either pass inn title and/or favicon-->
<!--Or put the content directly inside-->
